var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.visibleMenus.length
    ? _c(
        "div",
        {
          staticClass: "menu_switcher--container",
          class: _vm.containerClasses,
          style: _vm.containerStyles,
        },
        [
          _vm.isCollapsableOrMobileDockLeft
            ? _c(
                "a",
                {
                  staticClass:
                    "menu_switcher--handle visual_menu--glass_effect textual_menu--glass_effect",
                  attrs: {
                    href: "#",
                    title:
                      "Click to " +
                      (_vm.isOpen ? "close" : "open") +
                      " available menus for " +
                      _vm.menuPageTitle,
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      _vm.isOpen = !_vm.isOpen
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("menu_book"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isOpen,
                          expression: "!isOpen",
                        },
                      ],
                      staticClass: "text",
                    },
                    [_vm._v("Available Menus")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isOpen,
                          expression: "isOpen",
                        },
                      ],
                      staticClass: "text",
                    },
                    [_vm._v("Close")]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "viewport visual_menu--glass_effect textual_menu--glass_effect",
            },
            [
              _vm._l(_vm.visibleMenus, function (menu) {
                return [
                  _c(
                    "a",
                    {
                      staticClass: "menu_switcher--menu",
                      class: {
                        "menu_switcher--menu-active":
                          _vm.currentMenuId === menu.menu_id,
                      },
                      attrs: {
                        href: "#",
                        title:
                          "Click to see the " +
                          _vm.getMenuTitle(menu) +
                          " menu",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.switchMenus(menu.menu_id)
                        },
                      },
                    },
                    [
                      menu.menu_icon.length
                        ? _c(
                            "span",
                            {
                              staticClass: "menu_switcher--icon material-icons",
                              attrs: { "aria-hidden": "true" },
                            },
                            [_vm._v(_vm._s(menu.menu_icon))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isDockLeft || 1 > _vm.percentScroll,
                              expression: "isDockLeft || 1 > percentScroll",
                            },
                          ],
                          staticClass: "menu_switcher--title",
                        },
                        [_vm._v(_vm._s(menu.menu_type.mt_title))]
                      ),
                    ]
                  ),
                ]
              }),
            ],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }